import { useState } from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'
import Icon from '@/shared/components/atoms/Icon'

import TypeformModal from './TypeformModal'

export default function RequestCustomIntegrationButton() {
	const { t } = useTranslation('common')
	const [isModalOpen, setIsModalOpen] = useState(false)

	const handleRequestIntegration = () => {
		setIsModalOpen(true)
	}

	const handleCloseModal = () => {
		setIsModalOpen(false)
	}

	return (
		<>
			<Button
				variant="action"
				size="action"
				className="w-full md:w-auto"
				onClick={handleRequestIntegration}
			>
				<span>{t('integrations.request_custom')}</span>
				<Icon name="four-squares" className="w-3 h-3" />
			</Button>

			<TypeformModal isOpen={isModalOpen} onClose={handleCloseModal} />
		</>
	)
}
